export default __webpack_public_path__ + "static/media/marker_media_2_selected.084a7dc4.svg";